import { BASE_URL } from "constants/routes";
import React, { useCallback, useMemo, useState } from "react";
import { Row,Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import ZoomIn from "./../../assets/images/zoomIn.svg";
import "./Compare.scss";
import "./Zoom.scss";

const Zoom = ({ imageObject }) => {
  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );

  const [zoom, setZoom] = useState(1);
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [initialMouseX, setInitialMouseX] = useState(0); // initial mouse position
  const [initialMouseY, setInitialMouseY] = useState(0);
  const [initialX, setInitialX] = useState(0);
  const [initialY, setInitialY] = useState(0); // initial element position
  const [currentZoomPercentage, setCurrentZoomPercentage] = useState(0);

  const handleZoom = useCallback((event) => {
    // Get the current value of the slider
    const value = event.target.value;
    setZoom(event.target.value);

    // Get the min, max, and step attributes of the slider
    const min = event.target.min;
    const max = event.target.max;
    const step = event.target.step;

    const percentage =
      Math.round((((value - min) / (max - min)) * 100) / step) * step;

    setCurrentZoomPercentage(percentage);
  }, []);

  const handleMouseDown = useCallback(
    (e) => {
      setInitialX(x);
      setInitialY(y);
      setInitialMouseX(e.clientX);
      setInitialMouseY(e.clientY);
      setIsDragging(true);
    },
    [x, y]
  );

  const handleMouseMove = useCallback(
    (e) => {
      if (isDragging) {
        const dx = e.clientX - initialMouseX; // distance mouse has moved
        const dy = e.clientY - initialMouseY;
        setX(initialX + dx);
        setY(initialY + dy); // set new element position
      }
    },
    [isDragging, initialMouseX, initialMouseY, initialX, initialY]
  );

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  const imageSrc = useMemo(
    () =>
      `${BASE_URL}/workflow/viewUploadedDocument/${currentSubWorkFlowId}/${
        imageObject?.accessPath ? imageObject?.accessPath : imageObject.doc_name
      }/${imageObject.doc_id}`,
    [
      currentSubWorkFlowId,
      imageObject.doc_name,
      imageObject.doc_id,
      imageObject.doc_type,
      imageObject?.accessPath
    ]
  );

  return (
    <>
      {/* <div className="App"> */}
        <Row xs={12}>
          <Col
            className="scrollable-div zoomScrollDivonoom"
            style={{
              "::-webkit-scrollbar": {
                display: "none",
              },
              scrollTop: y,
              scrollLeft: x,
            }}
            onMouseMove={handleMouseMove} // drag
            onMouseUp={handleMouseUp} // stop dragging
          >
            {imageObject?.doc_type === ".pdf" || imageObject?.doc_type === ".PDF" ? 
            <object
              className="zoomImg"
              alt="Not Found"
              data={imageSrc}
              type="application/pdf"
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: `${x}px ${y}px`,
                position: "relative",
                left: x,
                top: y,
                width: "100%",
                height: "100%",
              }}
              onMouseDown={handleMouseDown}
            /> :
            <img
              className="zoomImg"
              alt="Not Found"
              src={imageSrc}
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: `${x}px ${y}px`,
                position: "relative",
                left: x,
                top: y,
                width: "100%",
                height: "100%",
              }}
              onMouseDown={handleMouseDown}
            />
            }
          </Col>
        </Row>
        {/* <Row xs={12}>
          <Col className="">On Zoom to move the image, use two fingers</Col>
        </Row> */}
        <Row xs={12} md={2} lg={2}  className="d-flex justify-content-center">
          <Col
            className="zoomDivimg h-25px bg-theme-grey-1 d-flex align-items-center justify-content-center mb-3"
            // style={{
            //   display: "flex",
            //   width: "100%",
            //   justifyContent: "center",
            //   alignItems: "center",
            // }}
          >
            <img
              className="zooomImagePadding h-35px"
              // style={{
              //   paddingRight: "10px",
              // }}
              src={ZoomIn}
              alt=""
            />
            <input
              // style={{
              //   height: "3px",
              //   width: "40%",
              //   marginRight: "10px",
              // }}
              className="zoomImageRangeStyle"
              //onhover show the zoom value as the tooltip

              title={`zoomed to ${currentZoomPercentage}%`}
              type="range"
              min="1"
              max="2"
              step="0.1"
              value={zoom}
              onChange={handleZoom}
            />
            <strong className="fs-10px">{currentZoomPercentage}%</strong>
          </Col>
        </Row>
      {/* </div> */}
    </>
  );
};
export default Zoom;
